module.exports = __webpack_public_path__ + "img/head6.94369ca2.png";